import PropTypes from 'prop-types';
import { LOCALES, PLATFORMS } from './constants';

export const InitialStatePropType = PropTypes.exact({
  campaign: PropTypes.shape({
    uuid: PropTypes.string,
    name: PropTypes.string,
    redirectionUrl: PropTypes.string,
    creativeDesktop: PropTypes.shape({
      url: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    creativeMobile: PropTypes.shape({
      url: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
  }),
  platform: PropTypes.oneOf(Object.values(PLATFORMS)),
  spaceSlug: PropTypes.string,
  isB2B: PropTypes.bool,
  userId: PropTypes.number,
  browserAPI: PropTypes.string,
  pageName: PropTypes.string,
  categoryId: PropTypes.number,
  ancestors: PropTypes.arrayOf(PropTypes.shape({})),
  hasTopbannerBeenFetched: PropTypes.bool,
  market: PropTypes.string,
});

export const IntlPropType = PropTypes.exact({
  messages: PropTypes.object,
  addLocaleData: PropTypes.func.isRequired,
  locale: PropTypes.oneOf(Object.values(LOCALES)),
});
